import axios, { AxiosResponse } from 'axios' 
import { ICreditCardCollectionModel } from './CreditCardCollectionModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const CREDITCARDCOLLECTION_CREATE_URL = `${API_URL}api/v1/customer/credit-card/create`

export function createCreditCardCollection(creditcardcollection: ICreditCardCollectionModel) {
  return axios.post(CREDITCARDCOLLECTION_CREATE_URL, creditcardcollection)
}

